export class TabSize {
  public static SIZE = 100;
}
